import dayjs from 'dayjs'
import { ONBOARDING_SESSION_DAYS } from './prototypeSettings'

/** Days left in the 30-day onboarding session (design manual p.3). */
export function daysRemaining(startedAt: string): number {
  const end = dayjs(startedAt).add(ONBOARDING_SESSION_DAYS, 'day')
  return Math.max(0, Math.ceil(end.diff(dayjs(), 'hour') / 24))
}
